import React from 'react';
import styled from 'styled-components';
import FeaturesPanel from './features-panel';
import { getFreeFeatures, getProFeatures } from '../../core/features'
import { Flex } from '~/components/basic/containers';

const Container = styled(Flex)`
  margin: auto;
`;

export default () => (
  <Container>
    <FeaturesPanel featuresInfo={getFreeFeatures()} />
    <FeaturesPanel featuresInfo={getProFeatures()} />
  </Container>
);